import $ from 'jquery';
import { axiosInstance as axios, handleAxiosErrors } from '../_utils';
import {
    convertDataToListingDisplay,
    convertProductSalePricesToAReadableFormat,
    convertProductsListingToAReadableFormat,
    convertProductCategoriesToAReadableFormat,
    getGraphQLTotalRecords,
    getShowProductPrice,
    buildFilterParams,
} from '../selectors/converterSelector';
import { buildRequestProductsParams } from '../selectors/productSelector';
import config from '../store/_config';
import { scrollTo } from '../dom/window';

export const toggleLoading = (value) => {
    return {
        type: 'TOGGLE_PRODUCT_LIST_LOADING',
        value: value,
    };
};
export const updateHasInitialized = (value) => {
    return {
        type: 'UPDATE_PRODUCT_LIST_HAS_INITIALIZED',
        value: value,
    };
};
export const replaceProductListDisplay = (value) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'UPDATE_PRODUCT_LIST_DISPLAY',
            value: value,
        });
    };
};
export const replaceProductCategories = (value) => {
    return {
        type: 'REPLACE_PRODUCT_CATEGORIES_TREE',
        value: value,
    };
};
export const replaceProductList = (value) => {
    return {
        type: 'REPLACE_PRODUCT_LIST',
        value: value,
    };
};
export const updateProductList = (value) => {
    return {
        type: 'UPDATE_PRODUCT_LIST',
        value: value,
    };
};
export const setActivePage = (value) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'SET_PRODUCT_LIST_ACTIVE_PAGE',
            value: value,
        });

        Promise.all([dispatch(requestProducts())]).then(() => {
            // scroll to the top
            if ($('.category-header').length) {
                scrollTo($('.category-header'));
            } else {
                scrollTo($('#product-listing'));
            }
        });
    };
};
export const setTotalRecords = (value) => {
    return {
        type: 'SET_PRODUCT_LIST_TOTAL_RECORDS',
        value: value,
    };
};
export const setSort = (sortBy, sortDirection) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'UPDATE_PRODUCT_LIST_SORT',
            value: sortBy,
            direction: sortDirection,
        });

        dispatch(requestProducts());
    };
};
export const setViewBy = (value) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'UPDATE_PRODUCT_LIST_VIEW_TYPE',
            value: value,
        });
    };
};
export const updateLivestockFilter = (key, value) => {
    return (dispatch, getState) => {
        const state = getState();

        const { filters } = state.product.listParams;
        let newFilters = {
            ...filters,
            LiveStockType: {
                ...filters.LiveStockType,
                [key]: value == 'true' || value === true,
            },
        };

        dispatch({
            type: 'UPDATE_PRODUCT_LIST_FILTERS',
            value: newFilters,
        });

        dispatch(requestProducts());
    };
};
export const requestProducts = () => {
    return (dispatch, getState) => {
        const state = getState();

        const { listParams } = state.product;
        const { activePage, perPage } = listParams;
        const currentRecordIndex = (activePage - 1) * perPage;
        const categoryID =
            typeof window.categoryID != 'undefined' ? window.categoryID : '';
        const searchKeyword = typeof window.q != 'undefined' ? window.q : '';

        let finalListParams = { ...listParams };
        if (categoryID) {
            finalListParams.filters.CategoryID = categoryID;
        }
        if (searchKeyword) {
            finalListParams.filters.q = searchKeyword;
        }

        const isGroupedByFamily =
            typeof finalListParams.filters.IsFeatured != 'undefined'
                ? finalListParams.filters.IsFeatured
                : false;

        dispatch(toggleLoading(true));

        // There are two types of request:
        // 1. Request by price (this is only happens when SORT = 'Price'
        // 2. Default product request (later on it requests the products)

        if (finalListParams.sortBy == 'Price') {
            const showProductPrice = getShowProductPrice(state);
            const offset = (activePage - 1) * perPage;
            const priceParams = `CategoryID: ${categoryID}, SortOrder: "${
                finalListParams.sortDirection
            }", limit: ${perPage}, offset: ${offset}`;

            // Special request: by price
            axiosRequestSellPrice(priceParams).then((response) => {
                const list = convertProductSalePricesToAReadableFormat(
                    response.data.data.readBuyablePrices
                );
                const listingDisplay = convertDataToListingDisplay(
                    response.data.data.readBuyablePrices,
                    'BuyableID'
                );
                const total = getGraphQLTotalRecords(
                    response.data.data.readBuyablePrices
                );

                // wait for async requests
                Promise.all([dispatch(setTotalRecords(total))]).then(() => {
                    if (showProductPrice) {
                        dispatch(updateProductList(list));
                    }

                    axiosRequestProductsByIDs(listingDisplay).then(
                        (response) => {
                            const productList = convertProductsListingToAReadableFormat(
                                response.data.data.readProducts
                            );
                            dispatch(updateProductList(productList));

                            if (activePage > 1 && currentRecordIndex > total) {
                                dispatch(setActivePage(1));
                            }

                            dispatch(replaceProductListDisplay(listingDisplay));
                            dispatch(updateHasInitialized(true));
                            dispatch(toggleLoading(false));
                        }
                    );
                });
            });
        } else {
            // Normal axios request
            return axiosRequestProducts(finalListParams)
                .then((response) => {
                    const list = convertProductsListingToAReadableFormat(
                        response.data.data.readProducts
                    );
                    const listingDisplay = convertDataToListingDisplay(
                        response.data.data.readProducts,
                        'ID'
                    );
                    const total = getGraphQLTotalRecords(
                        response.data.data.readProducts
                    );

                    // wait for async requests
                    Promise.all([
                        dispatch(replaceProductListDisplay(listingDisplay)),
                        dispatch(updateProductList(list)),
                        dispatch(setTotalRecords(total)),
                    ]).then(() => {
                        dispatch(updateHasInitialized(true));
                        dispatch(toggleLoading(false));

                        if (listingDisplay && listingDisplay.length) {
                            dispatch(
                                requestSellPrice(
                                    listingDisplay,
                                    isGroupedByFamily
                                )
                            );
                        }

                        if (activePage > 1 && currentRecordIndex > total) {
                            dispatch(setActivePage(1));
                        }
                    });
                })
                .catch((error) => {
                    dispatch(updateHasInitialized(true));
                    dispatch(toggleLoading(false));
                    handleAxiosErrors(error);
                });
        }
    };
};
export const requestSellPrice = (buyableIDs, isGroupedByFamily = false) => {
    return (dispatch, getState) => {
        const state = getState();

        const showProductPrice = getShowProductPrice(state);

        if (showProductPrice) {
            axiosRequestSellPriceByBuyableIDs(buyableIDs, isGroupedByFamily)
                .then((response) => {
                    const prices = convertProductSalePricesToAReadableFormat(
                        response.data.data.readBuyablePrices
                    );

                    if (isGroupedByFamily) {
                        // Create an array of Family Title Slug x BuyableID
                        let productByFamilyTitleSlug = {};

                        // console.log(state.product.list);

                        Object.entries(state.product.list).forEach(
                            ([key, product]) => {
                                console.log(product);
                                if (product) {
                                    if (
                                        typeof productByFamilyTitleSlug[
                                            product.FamilyTitleSlug
                                        ] == 'undefined'
                                    ) {
                                        productByFamilyTitleSlug[
                                            product.FamilyTitleSlug
                                        ] = {};
                                    }

                                    productByFamilyTitleSlug[
                                        product.FamilyTitleSlug
                                    ][product.ID] = product.ID;
                                }
                            }
                        );

                        // Now update the price payload
                        let groupedPrices = {};
                        Object.entries(prices).forEach(([key, price]) => {
                            if (
                                typeof productByFamilyTitleSlug[key] !=
                                    'undefined' &&
                                productByFamilyTitleSlug[key]
                            ) {
                                const buyableIDs =
                                    productByFamilyTitleSlug[key];

                                Object.keys(buyableIDs).forEach((buyableID) => {
                                    groupedPrices[buyableID] = {
                                        ...price,
                                        BuyableID: buyableID,
                                    };

                                    delete groupedPrices[buyableID]
                                        .ProductFamilyRef;
                                });
                            }
                        });

                        console.log(productByFamilyTitleSlug);
                        console.log(groupedPrices);

                        dispatch(updateProductList(groupedPrices));
                    } else {
                        dispatch(updateProductList(prices));
                    }
                })
                .catch((error) => handleAxiosErrors(error));
        }
    };
};
export const requestProductCategories = () => {
    return (dispatch, getState) => {
        axiosRequestProductCategories()
            .then((response) => {
                const list = convertProductCategoriesToAReadableFormat(
                    response.data.data.readProductCategories
                );

                dispatch(replaceProductCategories(list));
            })
            .catch((error) => handleAxiosErrors(error));
    };
};
export const axiosRequestProductCategories = () => {
    let { url, query } = config.product.categories;

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};
export const axiosRequestSellPriceByBuyableIDs = (
    buyableIDs,
    aggregateByFamily = false
) => {
    let { url, query } = config.product.prices;

    let params = {
        BuyableIDs: buyableIDs.join(', '),
    };

    if (aggregateByFamily) {
        params.AggregateByFamily = aggregateByFamily;
    }

    query = query.replace(/{params}/, buildFilterParams(params));

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};
export const axiosRequestSellPrice = (params) => {
    let { url, query } = config.product.prices;
    query = query.replace(/{params}/, params);

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};
export const axiosRequestProducts = (params) => {
    let { url, query } = config.product.listing;
    query = query.replace(/{params}/, buildRequestProductsParams(params));

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};
export const axiosRequestProductsByIDs = (ids) => {
    let { url, query } = config.product.listingByIDs;
    query = query.replace(/{ids}/, `[${ids.join(',')}]`);

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};

export const axiosRequestProductsByCodeTagFamily = (codeTagFamily) => {
    let { url, query } = config.product.tagWizardVariations;
    query = query.replace(
        /{params}/,
        `Filters: {
            CodeTagFamily: ["${codeTagFamily.toUpperCase()}"]
        }`
    );

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};